<template>
  <div>
    <v-btn @click="pub()">pub</v-btn>
    <v-btn @click="sub()">sub</v-btn>

    
  </div>
</template>
<script type="text/javascript">
// var parser = require('xml2json')
// const servers = ['nats://0.0.0.0:4222']
// const NATS = require('nats')
// const nc = NATS.connect({ noRandomize: true, servers: servers })
// const nats = require('nats').connect('nats://203.154.71.118:4222')
// import {connect} from 'ts-nats'
// let nc = connect({servers: ['nats://203.154.71.118:4222']})

export default {
  data () {
    return {
      res: {},
      user: '',
      expire: '',
      roomsocket: ''
    }
  },
  mounted () {
    // publish an event every second
    // setInterval(() => {
    //   console.log('ttt')
    //   this.$nats.publish('events.server-5387', {
    //     cpu: 56,
    //     memory: 512,
    //     epoch: Date.now()
    //   })
    //   this.$nats.subscribe('events.*', (event) => {
    //     console.log('Server reading:', event)
    //   })
    // }, 1000)

    // subscribe to all server IDs
    // this.$nats.subscribe('events.*', (event) => {
    //   console.log('Server reading:', event)
    // })
  },
  created () {
    // nc.on('connect', () => {
    //   console.log('Connected to ' + nc.currentServer.url.host)
    // })
    // var me = this
    // this.$OnechatSocket.on('connect', function () {
    //   console.log('connect')
    //   me.$OnechatSocket.emit('join', {room: 'U60af97ed5e255a979e5ec83eac46f446', type: 'web'})
    //   me.$OnechatSocket.on('message', function (data) { console.log(data) })
    //   me.$OnechatSocket.on('disconnect', function () { console.log('test') })
    // })
    // nats.request('help', null, { max: 1, timeout: 1000 }, (msg) => {
    //   console.log('request timed out')
    // })

    // // Replies
    // nats.subscribe('help', function (request, replyTo) {
    //   nats.publish(replyTo, 'I can help!')
    // })

    // setTimeout(() => {
    //   nats.close()
    // }, 5000)
  },
  methods: {
    pub () {
      // console.log('foo')
      // nc.publish('foo', 'Hello World!')
      // // nats.publish('reply', JSON.stringify({result: {model: {message: 'Hello, World!'}}}))
      // this.$nats.publish('foo', 'Hello World!')
    },
    sub () {
      // nats.subscribe('foo', function (msg) {
      //   console.log('Received a message: ' + msg)
      // })
      // console.log('test')
      // this.$nats.subscribe('foo', (event) => {
      //   console.log('Server reading:', event)
      // })
      // this.$nats.subscribe('events.*', (event) => {
      //   console.log('Server reading:', event)
      // })
    },
    rss () {
      var feedURL = 'http://rssfeeds.sanook.com/rss/feeds/sanook/news.index.xml'
      $.ajax({
        type: 'GET',
        url: 'https://api.rss2json.com/v1/api.json?rss_url=' + feedURL,
        dataType: 'jsonp',
        success: function (result) {
          console.log(result)
        }
      })
      // this.$http.get('https://www.posttoday.com/rss/src/breakingnews.xml').then((response) => {
      //   console.log(response.body)
      // }, (response) => {})
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/test2.vue